import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import $9zSjX$intlStringsmjs from "./intlStrings.mjs";
import {ProgressCircle as $1cfe37e7feefa23d$export$c79b9d6b4cc92af7} from "../progress/ProgressCircle.mjs";
import {SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686, useSlotProps as $62024859ff9f1f8a$export$1e5c9e6e4e15efe3} from "../utils/Slots.mjs";
import "../button_vars.css";
import $9zSjX$button_vars_cssmjs from "../button_vars_css.mjs";
import {Text as $f8cc90fea9436c19$export$5f1af8db9871e1d6} from "../text/Text.mjs";
import {useFocusableRef as $3c2c983d5210446c$export$96a734597687c040} from "../utils/useDOMRef.mjs";
import {useHasChild as $f57c7d8d50bdc255$export$e52e2242b6d0f1d4} from "../utils/useHasChild.mjs";
import {useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useButton as $9zSjX$useButton} from "react-aria/useButton";
import {FocusRing as $9zSjX$FocusRing} from "react-aria/FocusRing";
import {isAppleDevice as $9zSjX$isAppleDevice, isFirefox as $9zSjX$isFirefox} from "react-aria/private/utils/platform";
import {mergeProps as $9zSjX$mergeProps} from "react-aria/mergeProps";
import $9zSjX$react, {useState as $9zSjX$useState, useEffect as $9zSjX$useEffect} from "react";
import {useFocus as $9zSjX$useFocus} from "react-aria/useFocus";
import {useHover as $9zSjX$useHover} from "react-aria/useHover";
import {useId as $9zSjX$useId} from "react-aria/useId";
import {useLocalizedStringFormatter as $9zSjX$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


















function $36a99e6d76bd9d26$var$disablePendingProps(props) {
    // Don't allow interaction while isPending is true
    if (props.isPending) {
        props.onPress = undefined;
        props.onPressStart = undefined;
        props.onPressEnd = undefined;
        props.onPressChange = undefined;
        props.onPressUp = undefined;
        props.onKeyDown = undefined;
        props.onKeyUp = undefined;
        props.onClick = undefined;
        props.href = undefined;
    }
    return props;
}
const $36a99e6d76bd9d26$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $9zSjX$react).forwardRef(function Button(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $62024859ff9f1f8a$export$1e5c9e6e4e15efe3)(props, 'button');
    props = $36a99e6d76bd9d26$var$disablePendingProps(props);
    let { elementType: Element = 'button', children: children, variant: variant, style: style = variant === 'accent' || variant === 'cta' ? 'fill' : 'outline', staticColor: staticColor, isDisabled: isDisabled, isPending: isPending, autoFocus: autoFocus, ...otherProps } = props;
    let domRef = (0, $3c2c983d5210446c$export$96a734597687c040)(ref);
    let { buttonProps: buttonProps, isPressed: isPressed } = (0, $9zSjX$useButton)(props, domRef);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $9zSjX$useHover)({
        isDisabled: isDisabled
    });
    let [isFocused, onFocusChange] = (0, $9zSjX$useState)(false);
    let { focusProps: focusProps } = (0, $9zSjX$useFocus)({
        onFocusChange: onFocusChange,
        isDisabled: isDisabled
    });
    let stringFormatter = (0, $9zSjX$useLocalizedStringFormatter)((0, ($parcel$interopDefault($9zSjX$intlStringsmjs))), '@react-spectrum/button');
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    let hasLabel = (0, $f57c7d8d50bdc255$export$e52e2242b6d0f1d4)(`.${(0, ($parcel$interopDefault($9zSjX$button_vars_cssmjs)))['spectrum-Button-label']}`, domRef);
    let hasIcon = (0, $f57c7d8d50bdc255$export$e52e2242b6d0f1d4)(`.${(0, ($parcel$interopDefault($9zSjX$button_vars_cssmjs)))['spectrum-Icon']}`, domRef);
    // an aria label will block children and their labels from being read, this is undesirable for pending state
    let hasAriaLabel = !!buttonProps['aria-label'] || !!buttonProps['aria-labelledby'];
    let [isProgressVisible, setIsProgressVisible] = (0, $9zSjX$useState)(false);
    let backupButtonId = (0, $9zSjX$useId)();
    let buttonId = buttonProps.id || backupButtonId;
    let iconId = (0, $9zSjX$useId)();
    let textId = (0, $9zSjX$useId)();
    let spinnerId = (0, $9zSjX$useId)();
    (0, $9zSjX$useEffect)(()=>{
        let timeout;
        if (isPending) // Start timer when isPending is set to true.
        timeout = setTimeout(()=>{
            setIsProgressVisible(true);
        }, 1000);
        else // Exit loading state when isPending is set to false. */
        setIsProgressVisible(false);
        return ()=>{
            // Clean up on unmount or when user removes isPending prop before entering loading state.
            clearTimeout(timeout);
        };
    }, [
        isPending
    ]);
    if (variant === 'cta') variant = 'accent';
    else if (variant === 'overBackground') {
        variant = 'primary';
        staticColor = 'white';
    }
    const isPendingAriaLiveLabel = `${hasAriaLabel ? buttonProps['aria-label'] : ''} ${stringFormatter.format('pending')}`.trim();
    const isPendingAriaLiveLabelledby = hasAriaLabel ? buttonProps['aria-labelledby']?.replace(buttonId, spinnerId) ?? spinnerId : `${hasIcon ? iconId : ''} ${hasLabel ? textId : ''} ${spinnerId}`.trim();
    let ariaLive = 'polite';
    if ((0, $9zSjX$isAppleDevice)() && (!hasAriaLabel || (0, $9zSjX$isFirefox)())) ariaLive = 'off';
    let isPendingProps = isPending ? {
        onClick: (e)=>{
            if (e.currentTarget instanceof HTMLButtonElement) e.preventDefault();
        }
    } : {
        // no-op. 
        // Not sure why, but TypeScript wouldn't allow to have an empty object `{}`.
        onClick: ()=>{}
    };
    return /*#__PURE__*/ (0, $9zSjX$react).createElement((0, $9zSjX$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9zSjX$button_vars_cssmjs))), 'focus-ring'),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $9zSjX$react).createElement(Element, {
        ...styleProps,
        ...(0, $9zSjX$mergeProps)(buttonProps, hoverProps, focusProps, isPendingProps),
        id: buttonId,
        ref: domRef,
        "data-variant": variant,
        "data-style": style,
        "data-static-color": staticColor || undefined,
        "aria-disabled": isPending ? 'true' : undefined,
        "aria-label": isPending ? isPendingAriaLiveLabel : buttonProps['aria-label'],
        "aria-labelledby": isPending ? isPendingAriaLiveLabelledby : buttonProps['aria-labelledby'],
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9zSjX$button_vars_cssmjs))), 'spectrum-Button', {
            'spectrum-Button--iconOnly': hasIcon && !hasLabel,
            'is-disabled': isDisabled || isProgressVisible,
            'is-active': isPressed,
            'is-hovered': isHovered,
            'spectrum-Button--pending': isProgressVisible
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $9zSjX$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            icon: {
                id: iconId,
                size: 'S',
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9zSjX$button_vars_cssmjs))), 'spectrum-Icon')
            },
            text: {
                id: textId,
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9zSjX$button_vars_cssmjs))), 'spectrum-Button-label')
            }
        }
    }, typeof children === 'string' ? /*#__PURE__*/ (0, $9zSjX$react).createElement((0, $f8cc90fea9436c19$export$5f1af8db9871e1d6), null, children) : children, isPending && /*#__PURE__*/ (0, $9zSjX$react).createElement("div", {
        "aria-hidden": "true",
        style: {
            visibility: isProgressVisible ? 'visible' : 'hidden'
        },
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($9zSjX$button_vars_cssmjs))), 'spectrum-Button-circleLoader')
    }, /*#__PURE__*/ (0, $9zSjX$react).createElement((0, $1cfe37e7feefa23d$export$c79b9d6b4cc92af7), {
        "aria-label": isPendingAriaLiveLabel,
        isIndeterminate: true,
        size: "S",
        staticColor: staticColor
    })), isPending && /*#__PURE__*/ (0, $9zSjX$react).createElement((0, $9zSjX$react).Fragment, null, /*#__PURE__*/ (0, $9zSjX$react).createElement("div", {
        "aria-live": isFocused ? ariaLive : 'off'
    }, isProgressVisible && /*#__PURE__*/ (0, $9zSjX$react).createElement("div", {
        role: "img",
        "aria-labelledby": isPendingAriaLiveLabelledby
    })), /*#__PURE__*/ (0, $9zSjX$react).createElement("div", {
        id: spinnerId,
        role: "img",
        "aria-label": isPendingAriaLiveLabel
    })))));
});


export {$36a99e6d76bd9d26$export$353f5b6fc5456de1 as Button};
//# sourceMappingURL=Button.mjs.map
